import { env, isNonProd } from '@/constant/env';
import { simpleSlugify } from '@/utils/slugify';

export const findTrackers = [
  'section',
  'component',
  'type',
  'context',
] as const;

export const phTrackerKey = 'data-ph-tracker';

export function passPhTracker(phTracker?: string | null) {
  if (!phTracker) return {};
  return { [phTrackerKey]: phTracker };
}

/*
 * Get the data tracker for the given element
 * It will build tracker in such format: {section}_{component}_{type}_{inner-text|context}
 * type is "link" or "button" because all clicables are either links or buttons
 * if context is not provided, it will use inner text
 * @param target - The element to get the data tracker for
 * @returns The data tracker
 */
export function getDataTracker(target: HTMLElement) {
  // allow only to have context or target inner text but not both
  let hasContext = false;

  let trackerCombined = '';

  for (let i = 0; i < findTrackers.length; i++) {
    const tracker = findTrackers[i];

    const dataTracker = target
      .closest(`[data-tracker-${tracker}]`)
      ?.getAttribute(`data-tracker-${tracker}`);

    if (dataTracker) {
      trackerCombined = `${trackerCombined}_${simpleSlugify(dataTracker)}`;

      if (tracker === 'context') {
        hasContext = true;
      }
    } else if (
      tracker !== 'context' &&
      env.publicIgnoreDataTrackerLogs !== 'true'
    ) {
      isNonProd &&
        // Deliberately kept as console.log instead of logger so it retains reference to the original element
        // eslint-disable-next-line no-console
        console.log(
          `No tracker found with text "${target.textContent}" - in tracker type "${tracker}" - for element:`,
          target
        );
    }
  }

  if (!hasContext && target.textContent) {
    const slugishText = simpleSlugify(target.textContent);
    trackerCombined = `${trackerCombined}_${slugishText}`;
  }

  if (trackerCombined) {
    trackerCombined = trackerCombined.substring(1);
  }

  return trackerCombined;
}
